import Vue from 'vue'
import axios from 'axios'
import {
  isCategoryAllowed,
  onConsentChange,
  ConsentCategories,
} from '@/libs/consent'

/* 1 ─ Axios instance ------------------------------------------------ */
const axiosIns = axios.create({
  baseURL: `https://${process.env.VUE_APP_BACKEND_API_HOSTNAME}/api`,
})

Vue.prototype.$http = axiosIns

/* 2 ─ anon-id helpers ----------------------------------------------- *
 * `anon_id` is a pseudonymous identifier used to group anonymous
 * requests from the same browser. Under GDPR / ePrivacy it is NOT a
 * strictly-necessary cookie, so we only set it after the user has
 * granted consent for the "functional" category.
 * ------------------------------------------------------------------ */
const ANON_COOKIE = 'anon_id'
const ANON_MAX_AGE = 60 * 60 * 24 // 24h

function readAnonCookie() {
  const m = document.cookie.match(/(?:^|;\s*)anon_id=([^;]+)/)
  return m ? m[1] : null
}

function writeAnonCookie(id) {
  document.cookie = `${ANON_COOKIE}=${id};Path=/;SameSite=Lax;Secure;Max-Age=${ANON_MAX_AGE}`
}

function clearAnonCookie() {
  // Expire the cookie immediately.
  document.cookie = `${ANON_COOKIE}=;Path=/;SameSite=Lax;Secure;Max-Age=0`
}

function getOrSetAnonId() {
  if (!isCategoryAllowed(ConsentCategories.FUNCTIONAL)) return null

  const existing = readAnonCookie()
  if (existing) return existing

  const id = crypto.randomUUID()
  writeAnonCookie(id)
  return id
}

/* 3 ─ React to consent changes -------------------------------------- */
onConsentChange(consent => {
  if (!consent || !consent.functional) {
    clearAnonCookie()
  }
})

/* 4 ─ Request interceptor ------------------------------------------- */
axiosIns.interceptors.request.use(async cfg => {
  const id = getOrSetAnonId()
  if (id) {
    cfg.headers['X-Anon-Id'] = id
  }
  return cfg
})

/* 5 ─ exports ------------------------------------------------------- */
export { axiosIns } // named (tree-shakable)
export default axiosIns // keep default so old `import axios from '@axios'` works
